export default __webpack_public_path__ + "static/media/main-banner-3.04fdfe22.jpg";